'use client';

import { useRef } from 'react';
import styles from './VideoSlide.module.scss';
import style from "./CityDetailReviews.module.scss"
import PlayIcon from '@/SvgIcons/PlayIcon';
import { getYouTubeVideoId } from '@/data/homepage-revamp-static-data';
import { addStaticSubdomain } from "@/revamp/molecules/ProgramCard/utils";

export default function VideoSlide({ data, index, handlePlayClick }) {

  const videoId = getYouTubeVideoId(data?.video);
  const thumb = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

  return (
    <div className={styles.videoContainer}>
      <div className={style.reviewHead}>
        <div className={style.reviewerImg}>
          <img
            src={addStaticSubdomain(data?.image || "https://amityonline.com/_s/Pi7_Image_Cropper_1_9bcfd61426.webp")}
            alt={data?.name || `reviewer-${index + 1}`}
            width={100}
            height={100}
            loading="lazy"
            decoding="async"
          />
        </div>
        <div className={style.reviewerDetails}>
          <h3 className={style.reviewerName}>
            {data?.name || ""}
          </h3>
          <p className={style.reviewerDegree}>
            {data?.title || ""}
          </p>
        </div>
      </div>

      <div className={styles.preview} style={{ width: "100%", height: "100%", position: "relative" }}>
        <img
          src={thumb}
          alt="YouTube Thumbnail"
          style={{ objectFit: "cover", borderRadius: 12, height: "100%", width: "100%" }}
        />
        <button className={styles.playButton} onClick={() => handlePlayClick(data?.video)} id="video-play-btn" aria-label="Play Video">
          <PlayIcon />
        </button>
      </div>

      <button
        className={styles.readMoreBtn}
        onClick={() => handlePlayClick(data?.video)}
        id={"read-full-testimonial-" + index}
      >
        Watch Now
      </button>
    </div>
  );
}
